import styled from '@emotion/styled'

export const StyledButton = styled.button`
  font: inherit;
  color: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 1em;
  box-sizing: border-box;
  background: ${props => props.theme.primaryDark[props['data-color']] ?? props.theme.text};
  color: ${props => props.theme.primaryLight[props['data-color']] ?? props.theme.background};
  border: 2px solid ${props => props.theme.primaryDark[props['data-color']] ?? props.theme.text};
  margin: 0;
  padding: .5em 1.4em;
  text-decoration: none;
  cursor: pointer;
  text-align: center;

  &[data-secondary=true] {
    background: ${props => props.theme.primaryLight[props['data-color']] ?? props.theme.menuHighlight};
    color: ${props => props.theme.primaryDark[props['data-color']] ?? props.theme.text};
  }

  &[data-fullwidth=true] {
    width: 100%;
    flex: 1;
  }

  &:disabled {
    cursor: default;
    opacity: .5;
  }
`